import { Button } from 'theme-ui';
import { useTheme } from '~/gatsby-plugin-theme-ui';

type Props = {
  handleSizeClick?: (size: Queries.OptionValuesFragmentFragment) => void;
  size: Queries.OptionValuesFragmentFragment;
  selectedSize: Queries.OptionValuesFragmentFragment | null;
  isAvailable: boolean;
};

const QuickshopSizeButton = ({ handleSizeClick, size, selectedSize, isAvailable }: Props) => {
  const isSelected = selectedSize?.slug === size?.slug && isAvailable;
  const handleClick = () => {
    if (handleSizeClick) handleSizeClick(size);
  };

  const {
    theme: {
      colors: { UIGray1, white, black, backgroundGrey },
    },
  } = useTheme();

  const getBackgroundColor = () => {
    if (!isAvailable) return backgroundGrey;
    if (isSelected) return black;
    return white;
  };
  const getTextColor = () => {
    if (!isAvailable) return UIGray1;
    if (isSelected) return white;
    return black;
  };
  return (
    <Button
      onClick={handleClick}
      variant="bare"
      sx={{
        fontFamily: 'inherit',
        fontSize: '1.4rem',
        fontWeight: 400,
        px: '1.6rem',
        py: '1.2rem',
        width: 'fit-content',
        borderRadius: '4px',
        border: '1px solid',
        borderColor: isSelected ? 'black' : 'cloud',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: getBackgroundColor(),
        color: getTextColor(),
        position: 'relative',
        lineHeight: 1,
        overflow: 'hidden',
        ...(!isAvailable && {
          '::after': {
            content: '""',
            position: 'absolute',
            left: '-2px',
            right: '-2px',
            top: '50%',
            height: '1px',
            backgroundColor: 'UIGray1',
            transform: 'rotate(-45deg) translateY(-50%)',
            transformOrigin: 'center',
            pointerEvents: 'none',
          },
        }),
      }}
    >
      {size.presentation}
    </Button>
  );
};

export default QuickshopSizeButton;
